// assets
import DashboardIcon from '@mui/icons-material/Dashboard';
// icons
const icons = {
  DashboardIcon
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: '',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardIcon,
      breadcrumbs: true
    }
  ]
};

export default dashboard;
